module.exports = __webpack_public_path__ + "static/media/ти.e1e3d967.mp3";